export default "__VITE_ASSET__zzbmb_30__"